import { Text, Link, Flex, Button, Box } from '@chakra-ui/react';
import { setTeasers } from '../../MultiSection/SummaryBox/utils';
import { onLink, setResume } from '../../../handlers';
import React from 'react';

const Details = ({ styles, uv, props }) => {
  const values = uv.formikProps.values;
  const teasers = setTeasers(props.sections, values, uv.resumeIndex);
  return (
    <Flex sx={{ ...styles.resumeSummary.detailsDisplay }}>
      <Box     >
        <Link sx={{ ...styles.resumeSummary.head }} onClick={() =>
          setResume(
            props, uv.resumeIndex,
          )
        }>{teasers.head}</Link>
        <Box >{teasers.subhead}</Box>
      </Box>
      <Box sx={{ ...styles.resumeSummary.subhead }}>
        <Box marginBottom="1rem" >
          <Button   padding='0 4rem !important' onClick={() => onLink(false, uv.formikProps, uv.stateProps, 'job-posting', 0,  'section', uv.resumeIndex)}>+ Cover Letter</Button>
        </Box>
        <Box>
          <Button  padding='0 4rem' onClick={() => onLink(false, uv.formikProps, uv.stateProps, 'interview', 0,  'section', uv.resumeIndex)}>Interview Prep</Button>
        </Box>
      </Box>
    </Flex>
  );
};

export default Details;
